var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllusSite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "190px",
    viewBox: "0 0 190 190",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illus_site") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-41.7%",
    y: "-119.7%",
    width: "183.3%",
    height: "339.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.6,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 0,
    y: 22.0952381,
    width: 68.4,
    height: 60.952381,
    rx: 1.52
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.0%",
    y: "-5.7%",
    width: "116.1%",
    height: "118.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "3.061617e-15%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-41.7%",
    y: "-119.7%",
    width: "183.3%",
    height: "339.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.6,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-6",
    x: 45.6,
    y: 0,
    width: 68.4,
    height: 91.4285714,
    rx: 1.52
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.0%",
    y: "-3.8%",
    width: "116.1%",
    height: "112.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.290196078   0 0 0 0 0.6  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "illus_site"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#EEF4FA",
    cx: 95,
    cy: 95,
    r: 95
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(38.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    fillOpacity: 0.2,
    fill: "#004A99",
    filter: "url(#filter-1)",
    points: "6.84 83.8095238 61.56 83.8095238 61.56 64.7619048 6.84 64.7619048"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 7.6,
    y: 29.7142857,
    width: 18.24,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 33.44,
    y: 29.7142857,
    width: 18.24,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 7.6,
    y: 46.4761905,
    width: 18.24,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 33.44,
    y: 64.7619048,
    width: 18.24,
    height: 18.2857143
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 33.44,
    y: 46.4761905,
    width: 18.24,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    fillOpacity: 0.2,
    fill: "#004A99",
    filter: "url(#filter-5)",
    points: "52.44 96 107.16 96 107.16 76.952381 52.44 76.952381"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 92.72,
    y: 65.5238095,
    width: 10.64,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 92.72,
    y: 47.2380952,
    width: 10.64,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 56.24,
    y: 65.5238095,
    width: 10.64,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 74.48,
    y: 47.2380952,
    width: 10.64,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 56.24,
    y: 47.2380952,
    width: 10.64,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 92.72,
    y: 28.952381,
    width: 10.64,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 74.48,
    y: 28.952381,
    width: 10.64,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 56.24,
    y: 28.952381,
    width: 10.64,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 92.72,
    y: 10.6666667,
    width: 10.64,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 74.48,
    y: 10.6666667,
    width: 10.64,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "url(#linearGradient-4)",
    x: 56.24,
    y: 10.6666667,
    width: 10.64,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    fill: "url(#linearGradient-4)",
    x: 72.2,
    y: 65.5238095,
    width: 15.2,
    height: 25.9047619
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusSite);
export default __webpack_public_path__ + "static/media/illus-site.b726d602e87ff1c6ff03f2cfeeb941b1.svg";
export { ForwardRef as ReactComponent };